"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const components_1 = require("./../../../components");
const models_1 = require("./../../../components/Datagrid/models");
exports.MapDatagrid = () => (React.createElement(components_1.Datagrid, { noDefaultFilter: true, noFiltersHeader: true, noHeader: true, noPagination: true, viewMode: models_1.ViewMode.map },
    React.createElement(components_1.DatagridMapView, null, "Map here"),
    React.createElement(components_1.DatagridFiltersSlot, null,
        React.createElement(components_1.DatagridFilter, { label: "Layers", noResetButton: true },
            React.createElement("select", { className: "custom-select w-100" },
                React.createElement("option", null, "States"),
                React.createElement("option", null, "Counties"))))));
exports.MapDatagrid.displayName = 'MapDatagrid';



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/Datagrid/MapDatagrid.tsx
// module id = 473
// module chunks = 0